<template>
  <v-dialog
    v-model="dialog"
    width="400px"
    @closed="closed">
    <div class="header flex">
      <p>{{title}}</p>
      <font-awesome-icon
        icon="times"
        class="close"
        @click="handleCancel"></font-awesome-icon>
    </div>
    <div class="body">
      <div class="main">
        <template v-if="step == 1">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div class="form-item">
              <span>Payment Proof</span>
              <el-form-item prop="url">
                <v-upload
                  card
                  notUpload
                  widthFull
                  :fileData="{
                    url: formData.url,
                    thumb_url: formData.url
                  }"
                  @uploadForm="handlerUploadSuccess"
                  @delete="handlerDeleteFile"></v-upload>
              </el-form-item>
            </div>
          </el-form>
        </template>
        <template v-else>
          <div class="tips">The payment proof has been successfully uploaded.</div>
        </template>
      </div>
      <div class="footer">
        <div class="btn flex">
          <template v-if="step == 1">
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
            <v-button
              green
              @click="handleContinue">Continue</v-button>
          </template>
          <template v-else>
            <v-button
              gray
              @click="handleCancel">OK</v-button>
            <v-button
              green
              @click="handleReview">Review Payment</v-button>
          </template>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {uploadBankFile} from '@/api/share'
export default {
  name: 'BankTransferSms',
  props:{
    orderId:{
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialog: false,
      formData:{
        file: null,
        url: ''
      },
      step: 1,
      rules:{
        url:[
          { required: true, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ]
      }
    }
  },
  computed:{
    title(){
      return this.step == 1? 'Upload Payment Proof' : 'Payment Proof Uploaded'
    },
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.changeDialog()
    },
    handleContinue(){
      this.$refs['form'].validate(valid => {
        if(valid){
          let params = new FormData()
          params.append('file', this.formData.file)
          params.append('order_id', this.orderId)
          this.network().uploadBankFile(params)
        }
      })
    },

    handleReview(){
      this.$emit('review')
      this.handleCancel()
    },

    closed(){
      this.step = 1
    },

    handlerUploadSuccess({ file, result }) {
      this.formData.url = result.url
      this.formData.file = file
      this.$refs['form'].clearValidate('url')
    },

    handlerDeleteFile() {
      this.$set(this.formData, 'file', null)
      this.$set(this.formData, 'url', '')
    },

    network(){
      return {
        uploadBankFile: async(params) => {
          const {data} = await uploadBankFile(params)
          if(data.code == 1000){
            this.$emit('update')
            this.step = 2
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .body{
    padding: 20px 15px 15px 15px;
    .main{
      .tips{
        color: #24292E;
      }
    }
    .footer{
      margin-top: 20px;
      .btn{
        justify-content: space-between;
      }
    }
  }
}
</style>
